import React, { Component } from 'react'
import { Container, Row, Col, Button } from 'reactstrap'
import styled from 'styled-components'
import { fontWeight } from 'themes/font'
import { inject, observer } from 'mobx-react'
import { renderText } from 'utils/text'
import { media } from 'styled-bootstrap-grid'
import PublicUrl from 'components/public-url'

const Section = styled.section`
  background: url('/img/home-page/hero-unit/bg.svg') no-repeat bottom;
  background-size: contain;
  padding-top: 32px;
  padding-bottom: 32px;
  .aboutTungtung {
    h1 {
      font-size: 40px;
      margin-top: 0;
      margin-bottom: 24px;
      font-weight: ${fontWeight.bold} !important;
      color: #333;
      span {
        margin-bottom: 8px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    p {
      font-size: 18px;
      margin-bottom: 24px !important;
    }
    .btn {
      font-size: 24px;
      border-radius: 8px;
      padding-left: 32px;
      padding-right: 32px;
      font-size: 18px;
      font-weight: ${fontWeight.bold};
    }
  }
  .featuredImage {
    width: 100%;
  }
  ${media.md`
    .aboutTungtung {
      h1 {
        font-size: 48px;
      }
    }
  `}
  ${media.lg`
    min-height: calc(100vh - 96px);
    padding-bottom: 96px;
    display: flex;
    align-items: center;
  `}
`

@inject('authStore')
@observer
class HeroUnit extends Component {
  render () {
    const { heading, content, button } = this.props.data
    return (
      <Section>
        <Container>
          <Row style={{ alignItems: 'center' }}>
            <Col lg={6}>
              <div className='aboutTungtung wow fadeIn'>
                <h1>{renderText(heading)}</h1>
                <p>{content}</p>
                <PublicUrl target='_blank' to={'/'}>
                  <Button size='lg' color='primary'>{button.text}</Button>
                </PublicUrl>
              </div>
            </Col>
            <Col lg={6}>
              <img
                src='/img/home-page/hero-unit/illustration.png'
                alt='FeatureImage'
                className='fadeIn featuredImage'
              />
            </Col>
          </Row>
        </Container>
      </Section>
    )
  }
}

export default HeroUnit
